module.exports = __webpack_public_path__ + "img/forum-label-tyjb.9a7e382d.png";